module.exports = __webpack_public_path__ + "static/media/sin_volumen.3f8c6c38.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Volume/sin_volumen.svg
// module id = 1857
// module chunks = 0